
import { BasicInfoScreenNavigationProps } from "./types"
import React from "react"
import BasicInfo from "./basic-info-screen"
import { PageRoot } from "~screens/page-root"


const BasicInfoScreen: React.FC<BasicInfoScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <BasicInfo />
    </PageRoot>
  )
}

export default BasicInfoScreen
